export var getPlayersWithNoCompany = function (players) {
    return players.filter(function (player) { return !player.companyID; });
};
